// extracted by mini-css-extract-plugin
export default {"org":"LeftTable_org__lTyX-","limitedCell":"LeftTable_limitedCell__9YpPp","summary":"LeftTable_summary__FSos8","placeHolderShimmer":"LeftTable_placeHolderShimmer__Jvp0K"};